import { ProcessAPI } from 'lecom-api';

import ProcessActionRoutes from 'process/constants/process_action_routes';
import { getCookie } from "../../utils/cookie_utils";
import RestClient from 'rest_client/rest_client';
import { serializePrivateProperties } from '../../utils/object_utils';

export default class CurrentUserHandler {

	static retrieveUserByTicket() {
		return this.user && this.user.login
		? Promise.resolve(this.user)
		: this.loadUser();
	}

	static loadUser() {
		return ProcessAPI.currentProcess().processInstanceData().publicFormEnabled
		? this.loadPublicFormUser()
		: this.loadUserByTicket();
	}

	static loadUserByTicket() {
		if (!this.pendingPromise)
			this.pendingPromise = this.performUserByTicketRequest(this.getLecomSSOTicket());

		return this.pendingPromise;
	}

	static performUserByTicketRequest(ticket) {
		const url = ProcessActionRoutes.GET_USER_BY_TICKET;

		return new Promise((resolve, reject) => {
			RestClient.get(url, { ticket })
			.then(response => this.handleUserByTicketRequestSuccess(response, resolve))
			.catch(err => this.handleUserByTicketRequestError(err, reject));
		});
	}

	static handleUserByTicketRequestError(err, reject) {
		reject(err);
		this.pendingPromise = null;
	}

	static handleUserByTicketRequestSuccess(response, resolve) {
		this.handleUserResponse(response, resolve);
		this.pendingPromise = null;
	}

	static handleUserResponse(response, resolve) {
		this.user = Object.assign({}, {
			login: response.entity.login,
			name: response.entity.name
		});

		resolve(this.user);
	}

	static getLecomSSOTicket() {
		const cookieSSOTicketKey = 'LecomSSOTicket';
		return getCookie(cookieSSOTicketKey) || ProcessAPI.currentProcess().ticket();
	}

	static loadPublicFormUser ()  {
		return this.performPublicFormUser(this.getProcessDefinitionId());
	}

	static getProcessDefinitionId(){
		const instanceData = ProcessAPI.currentProcess().processInstanceData();

		return Object.assign({}, {
			processId: instanceData.processId,
			version: instanceData.version,
			activityId: instanceData.activityInstanceId
		});
	}

	static performPublicFormUser(activityDefinitionId){
		const url = ProcessActionRoutes.GET_PUBLIC_FORM_USER;
		const params = serializePrivateProperties(activityDefinitionId);

		return new Promise((resolve, reject) => {
			RestClient.get(url, params)
			.then(response => this.handleUserResponse(response, resolve))
			.catch(reject)
		});
	}

	static getTestMode() {
		const cookieTestMode = 'LecomEnvironmentMode';
		return getCookie(cookieTestMode);
	}
};
